import * as React from 'react';
import styled from 'styled-components';

export const Deezer: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg width="58" height="30" viewBox="0 0 58 30" {...props}>
    <polygon points="0 29 0 28 10 28 10 30 0 30 " />
    <polygon points="0 25 0 24 10 24 10 26 0 26 " />
    <polygon points="0 21 0 20 10 20 10 22 0 22 " />
    <polygon points="0 17 0 16 10 16 10 18 0 18 " />
    <polygon points="0 13 0 12 10 12 10 14 0 14 " />
    <polygon points="24 29 24 28 34 28 34 30 24 30 " />
    <polygon points="24 25 24 24 34 24 34 26 24 26 " />
    <polygon points="24 21 24 20 34 20 34 22 24 22 " />
    <polygon points="24 17 24 16 34 16 34 18 24 18 " />
    <polygon points="24 13 24 12 34 12 34 14 24 14 " />
    <polygon points="24 9 24 8 34 8 34 10 24 10 " />
    <polygon points="24 5 24 4 34 4 34 6 24 6 " />
    <polygon points="48 29 48 28 58 28 58 30 48 30 " />
    <polygon points="48 25 48 24 58 24 58 26 48 26 " />
    <polygon points="48 21 48 20 58 20 58 22 48 22 " />
    <polygon points="48 17 48 16 58 16 58 18 48 18 " />
    <polygon points="48 13 48 12 58 12 58 14 48 14 " />
    <polygon points="48 9 48 8 58 8 58 10 48 10 " />
    <polygon points="48 5 48 4 58 4 58 6 48 6 " />
    <polygon points="48 1 48 0 58 0 58 2 48 2 " />
    <polygon points="36 29 36 28 46 28 46 30 36 30 " />
    <polygon points="36 25 36 24 46 24 46 26 36 26 " />
    <polygon points="36 21 36 20 46 20 46 22 36 22 " />
    <polygon points="36 17 36 16 46 16 46 18 36 18 " />
    <polygon points="36 13 36 12 46 12 46 14 36 14 " />
    <polygon points="12 29 12 28 22 28 22 30 12 30 " />
    <polygon points="12 25 12 24 22 24 22 26 12 26 " />
    <polygon points="12 21 12 20 22 20 22 22 12 22 " />
  </svg>
);

export default styled(Deezer)`
  & > polygon {
    fill: ${({ theme }) => theme.colors.primary};
  }
`;
